// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3u5Fa","errorLogs":"EditorFooter_errorLogs__3_R64"};